import { useAuthContext } from '@chocolate-soup-inc/cs-frontend-components';

export const useAuthContextUserEmail = () => {
  const auth = useAuthContext();
  return auth?.user?.email;
};
